import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/clientes/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function findCliente(empresa_cnpj, rowsPerFind, page, filter) {
  const filters = `${page ? `&page=${page}` : ""}${
    rowsPerFind ? `&per_page=${rowsPerFind}` : ""
  }${filter ? `&filter[razao]=${filter}` : ""}`;

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${filters}`,
    "GET",
    headers
  );
}

export function findCertificadoCliente(cliente_cnpj) {
  return search(
    `${process.env.REACT_APP_URL_API_ERP}/bigdata/v1/certificado_digital/${cliente_cnpj}`,
    "GET",
    headers
  );
}

export function createCertificadoCliente(body) {
  return search(
    `${process.env.REACT_APP_URL_API_ERP}/bigdata/v1/certificado_digital`,
    "POST",
    headers,
    body
  );
}

export function findClienteByCpfCnpj(empresa_cnpj, cpfcnpj) {
  return search(
    `${path}/0?empresa_cnpj=${empresa_cnpj}&cliente_buscar=${cpfcnpj}`,
    "GET",
    headers
  );
}

export function createCliente(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export function updateCliente(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteCliente(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}
